import {Validators} from '@angular/forms';

import {ClientStatusTriggersEnum} from '@spa/api';

import {InArrayValidator} from '@spa/validators';

import {Helper, RadioGroupControl} from '../../../app/shared/classes';
import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';

export const VerificationStatusesComponentRadioGroupControl = (): RadioGroupControl => {
    return new RadioGroupControl({
        name: 'status',
        value: null,
        placeholder: 'Status',
        validators: [
            Validators.required,

            InArrayValidator([
                ClientStatusTriggersEnum.PendingAcceptance,
                ClientStatusTriggersEnum.ForVerification,
                ClientStatusTriggersEnum.PutOnHold,
                ClientStatusTriggersEnum.Verify,
                ClientStatusTriggersEnum.Block,
                ClientStatusTriggersEnum.Activate,
                ClientStatusTriggersEnum.Terminate,
                ClientStatusTriggersEnum.Decline
            ])
        ],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: [
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.PendingAcceptance),
                value: ClientStatusTriggersEnum.PendingAcceptance,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.ForVerification),
                value: ClientStatusTriggersEnum.ForVerification,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.PutOnHold),
                value: ClientStatusTriggersEnum.PutOnHold,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Verify),
                value: ClientStatusTriggersEnum.Verify,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Block),
                value: ClientStatusTriggersEnum.Block,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Activate),
                value: ClientStatusTriggersEnum.Activate,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Terminate),
                value: ClientStatusTriggersEnum.Terminate,
                color: ColorCodesEnum.Primary
            },
            {
                label: Helper.textsHelper().getClientStatusNameByTrigger(ClientStatusTriggersEnum.Decline),
                value: ClientStatusTriggersEnum.Decline,
                color: ColorCodesEnum.Primary
            }
        ]
    });
};
